import React from "react";
import { FormValidationSummary, Stack, Text, ValidationResult } from "sprint-common-web";

interface CloudAssetsValidationSummaryProps {
    cloudAssetsValidationResult?: ValidationResult;
    isCloudAssetValidationInProgress: boolean;
}

export const CloudAssetsValidationSummary = ({
    cloudAssetsValidationResult,
    isCloudAssetValidationInProgress
}: CloudAssetsValidationSummaryProps): JSX.Element => {
    return (
        <Stack style={{ marginTop: 20 }}>
            <FormValidationSummary
                validationResult={cloudAssetsValidationResult}
                isValidating={isCloudAssetValidationInProgress}
                renderCustomMessage={renderMessage}
                styles={{ root: { padding: 0, marginTop: 10 } }}
            />
        </Stack>
    );
};

const renderMessage = (grouped: Map<string, string[]>, item: string): JSX.Element | undefined => {
    return (
        <Text nowrap={false} styles={{ root: { whiteSpace: "pre-wrap", fontSize: 12 } }}>
            {grouped.get(item)}
        </Text>
    );
};
